import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { selectActivityContentLocale, selectActivityFromContentDetailState } from 'component/page/detail/store/detail.selectors';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import DetailInViewWrapper from 'component/common/DetailInViewWrapper/DetailInViewWrapper';
import { setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';

export interface Props {
    isScrolling: boolean;
    href: string;
}

export const OVERVIEW_ELEMENT_NAME = 'activities-overview';

const ActivityOverview: React.FC<Props> = (props) => {
    const activity = useSelector(selectActivityFromContentDetailState);
    const cms = useSelector(selectCmsFromBootstrap);
    const contentLocale: string = useSelector(selectActivityContentLocale);

    if (!activity || !activity.description || activity.description.length === 0) {
        return null;
    }

    return (
        <DetailInViewWrapper tabHref={props.href} isScrolling={props.isScrolling} setSelectedTabCallback={setSelectedTabOnDetailsPage}>
            <Box
                data-element-name={OVERVIEW_ELEMENT_NAME}
                data-testid={OVERVIEW_ELEMENT_NAME}
                pb="8"
                pt="16"
                borderStyle="solid"
                borderColor="base.subtle"
                borderWidth={['1', '0', '0', '0']}
            >
                <Typography id={props.href} variant="body-s-strong" tag="h2" mb="4">
                    {cms[126848]}
                </Typography>
                <Box pb="4">
                    <Typography variant="body-s" lang={contentLocale} textColor="base.subtle" tag="span">
                        <AgodaMarkdown dataElementName="overview-description" input={activity.description} isActivityDescription={true} />
                    </Typography>
                </Box>
            </Box>
        </DetailInViewWrapper>
    );
};
ActivityOverview.displayName = 'ActivityOverview';

export default ActivityOverview;
